import { getScreenWidth } from './getScreenWidth';

/**
 * One-shot check for tablet-size viewports (768px to 1023px).
 * Matches Tailwind `md:` but below `lg:`.
 * Returns false during SSR (width 0).
 */
export function isTablet(): boolean {
  const width = getScreenWidth();
  return width >= 768 && width < 1024;
}
